const convertTypographyToCSS = (typography) => ({
    '--typography-1-font-size': `${typography.t1.fontSize}px`,
    '--typography-2-font-size': `${typography.t2.fontSize}px`,
    '--typography-3-font-size': `${typography.t3.fontSize}px`,
    '--typography-4-font-size': `${typography.t4.fontSize}px`,
    '--typography-5-font-size': `${typography.t5.fontSize}px`,
    '--typography-6-font-size': `${typography.t6.fontSize}px`,
    '--typography-7-font-size': `${typography.t7.fontSize}px`,
    '--typography-8-font-size': `${typography.t8.fontSize}px`,
    '--typography-9-font-size': `${typography.t9.fontSize}px`,
    '--typography-10-font-size': `${typography.t10.fontSize}px`,
    '--typography-11-font-size': `${typography.t11.fontSize}px`,
    '--typography-1-line-height': `${typography.t1.lineHeight}px`,
    '--typography-2-line-height': `${typography.t2.lineHeight}px`,
    '--typography-3-line-height': `${typography.t3.lineHeight}px`,
    '--typography-4-line-height': `${typography.t4.lineHeight}px`,
    '--typography-5-line-height': `${typography.t5.lineHeight}px`,
    '--typography-6-line-height': `${typography.t6.lineHeight}px`,
    '--typography-7-line-height': `${typography.t7.lineHeight}px`,
    '--typography-8-line-height': `${typography.t8.lineHeight}px`,
    '--typography-9-line-height': `${typography.t9.lineHeight}px`,
    '--typography-10-line-height': `${typography.t10.lineHeight}px`,
    '--typography-11-line-height': `${typography.t11.lineHeight}px`,
});
const FontSizes = {
    s8: 'var(--typography-1-font-size)',
    s10: 'var(--typography-2-font-size)',
    s12: 'var(--typography-3-font-size)',
    s14: 'var(--typography-4-font-size)',
    s16: 'var(--typography-5-font-size)',
    s20: 'var(--typography-6-font-size)',
    s24: 'var(--typography-7-font-size)',
    s30: 'var(--typography-8-font-size)',
    s36: 'var(--typography-9-font-size)',
    s42: 'var(--typography-10-font-size)',
    s60: 'var(--typography-11-font-size)',
};
const LineHeights = {
    l10: 'var(--typography-1-line-height)',
    l14: 'var(--typography-2-line-height)',
    l16: 'var(--typography-3-line-height)',
    l20: 'var(--typography-4-line-height)',
    l24: 'var(--typography-5-line-height)',
    l28: 'var(--typography-6-line-height)',
    l32: 'var(--typography-7-line-height)',
    l36: 'var(--typography-8-line-height)',
    l48: 'var(--typography-9-line-height)',
    l50: 'var(--typography-10-line-height)',
    l72: 'var(--typography-11-line-height)',
};
const Typography = {
    t1: {
        fontSize: FontSizes.s8,
        lineHeight: LineHeights.l10,
    },
    t2: {
        fontSize: FontSizes.s10,
        lineHeight: LineHeights.l14,
    },
    t3: {
        fontSize: FontSizes.s12,
        lineHeight: LineHeights.l16,
    },
    t4: {
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
    },
    t5: {
        fontSize: FontSizes.s16,
        lineHeight: LineHeights.l24,
    },
    t6: {
        fontSize: FontSizes.s20,
        lineHeight: LineHeights.l28,
    },
    t7: {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
    },
    t8: {
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l36,
    },
    t9: {
        fontSize: FontSizes.s36,
        lineHeight: LineHeights.l48,
    },
    t10: {
        fontSize: FontSizes.s42,
        lineHeight: LineHeights.l50,
    },
    t11: {
        fontSize: FontSizes.s60,
        lineHeight: LineHeights.l72,
    },
};

export { FontSizes, LineHeights, Typography, convertTypographyToCSS };
